import { Container, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { useAuthContext } from "src/auth/hooks";
import { JwtLoginView } from "src/sections/auth/custom";
import { useSearchParams } from "src/routes/hooks";
import { safeReturnTo } from "src/utils/safe-return-to";

export default function LoginPage() {
  const { authenticated } = useAuthContext();
  const searchParams = useSearchParams();
  const loginHref = useRef(window.location.href);
  const redirected = useRef(false);

  useEffect(() => {
    if (
      authenticated &&
      !redirected.current &&
      window.location.href === loginHref.current
    ) {
      redirected.current = true;
      window.location.replace(safeReturnTo(searchParams.get("returnTo")));
    }
  }, [authenticated, searchParams]);

  if (authenticated) return null;

  return (
    <>
      <Helmet>
        <title>{t("login")}</title>
      </Helmet>

      <Container sx={{ mt: 15 }} maxWidth="sm">
        <Typography variant="h2">{t("login")}</Typography>
        <JwtLoginView onClose={() => {}} />
      </Container>
    </>
  );
}
